"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = require("prop-types");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var Icon = function Icon(_ref) {
  var name = _ref.name,
    _ref$namespace = _ref.namespace,
    namespace = _ref$namespace === void 0 ? 'fas' : _ref$namespace,
    uniqueID = _ref.uniqueID;
  return _react.default.createElement("i", {
    className: (0, _classnames.default)('icon', namespace, "fa-".concat(name)),
    "data-testid": uniqueID
  });
};
Icon.propTypes = {
  name: _propTypes.string.isRequired,
  namespace: _propTypes.string,
  uniqueID: _propTypes.string
};
var _default = Icon;
exports.default = _default;